import CardImageMarkers from "../../../../components/CockpitCards/CardImageMarkers";
import { ATHERO } from "../../../../constants";


export default function EnergyAddOnCard() {
  

return (

    <CardImageMarkers 
    
        image={ATHERO}
        title="ATHEROSCLEROSIS PREVENTION"
        subtitle="Integrated assessment of lipid, glucose, and metabolic health, with markers for insulin sensitivity, oxidative stress, and cardiovascular risk"
        markersTitle=" 149,- incl. VAT"
        markers="Lp(a), Insulin, QUICKI, Homocysteine, Coenzyme Q10, Atherogenic Index of Plasma (AIP), Triglycerides-Glucose Index"
    />


)
}